/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Button, Heading, HStack, Icon, SimpleGrid, Spacer, VStack } from '@chakra-ui/react';
import { useMemo } from 'react';
import { LuMoveRight } from 'react-icons/lu';
import {
  FaRegUser,
  FaRegHeart,
  FaRegClock,
  FaRegEnvelope,
  FaRegUserCircle,
  FaRegFileAlt,
  FaClipboard,
  FaShieldAlt,
} from 'react-icons/fa';
import { Link, useNavigate } from 'react-router-dom';
import { ExternalLink } from '../../../../../../packages/ui/components/atoms/ExternalLink';
import { useProfile } from '../../../../../../packages/ui/contexts/ProfileProvider';
import { useTheme } from '../../../../../../packages/ui/contexts/ThemeProvider';

function ProfileLink({
  name,
  color,
  to,
  icon,
  isExternal,
}: {
  color: string;
  name: string;
  to: string;
  icon: any;
  isExternal?: boolean;
}) {
  const navigate = useNavigate();
  const element = useMemo(
    () => (
      <Box
        as="button"
        onClick={() => navigate(to)}
        borderRadius="lg"
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        alignItems={'flex-start'}
        backgroundColor="white"
        overflow="hidden"
        height="115px"
        padding="15px"
        boxShadow={'2px 2px 6px 0px #0000002E'}
        width="100%"
      >
        <Icon color={color} as={icon} boxSize={6} marginBottom="5px" />
        <Heading color="#292927" fontWeight={'500'} textAlign={'left'} fontSize="16px">
          {name}
        </Heading>
      </Box>
    ),
    [navigate, name, to, icon, isExternal]
  );

  if (isExternal) return <ExternalLink to={to}>{element}</ExternalLink>;

  return (
    <Link style={{ width: '100%' }} to={to}>
      {element}
    </Link>
  );
}

export function ProfileLinks() {
  const { profile, logout } = useProfile();
  const { id, colors, bookstoreLabels } = useTheme();

  if (!profile) return null;

  return (
    <VStack w="100%">
      <SimpleGrid columns={[2]} spacing={3} width="100%">
        <ProfileLink color={colors.primaryColor} name="Meus Dados" to="meus-dados" icon={FaRegUser} />
        <ProfileLink
          color={colors.primaryColor}
          name={`Adquirir mais ${bookstoreLabels?.plural}`}
          to={`planos/purchase-subscription-mobile/${btoa(profile.cpf + ':' + id)}`}
          icon={FaClipboard}
        />
        <ProfileLink color={colors.primaryColor} name="Notificações" to="notificacoes" icon={FaRegClock} />
        <ProfileLink color={colors.primaryColor} name="Fale Conosco" to="contato" icon={FaRegEnvelope} />
        <ProfileLink color={colors.primaryColor} name="Dependentes" to="dependentes" icon={FaRegUserCircle} />
        <ProfileLink
          color={colors.primaryColor}
          isExternal
          name="Termos de Uso"
          to="/legal/termos-de-uso"
          icon={FaRegFileAlt}
        />
        <ProfileLink
          color={colors.primaryColor}
          isExternal
          name="Política De Privacidade"
          to="/legal/politica-de-privacidade"
          icon={FaShieldAlt}
        />
      </SimpleGrid>

      <Button variant={''} marginTop={'10px'} onClick={() => logout()}>
        <Heading color={colors.primaryColor} fontWeight={'400'} fontSize={'18px'}>
          Sair
        </Heading>
      </Button>
    </VStack>
  );
}
